const FONT_EXT_MIME = {
  otf: 'font/otf',
  ttf: 'font/ttf',
  ttfv: 'font/ttf',
  tt: 'font/ttf'
}

/**
 * Resolve Content-Type for presigned PUT uploads.
 * Prefer a non-generic browser MIME; when empty or application/octet-stream
 * (common for .otf/.ttf on some OS/browsers), fall back to extension mapping.
 */
const getUploadContentType = (file) => {
  const browserType = file?.type?.trim().toLowerCase();

  if (browserType && browserType !== 'application/octet-stream') {
    return browserType;
  }

  const ext = file?.name?.split('.').pop()?.toLowerCase() || '';

  return FONT_EXT_MIME[ext] || 'application/octet-stream';
};

const BinaryHelper = (() => {
  const _getStyleName = (data) => {
    return data.styleName || ''
  }
  const _getFamilyName = (data) => {
    return data.familyName || ''
  }
  const _getFormat = (data) => {
    const format = []
    if (typeof data.fontFormat === 'string') {
      format.push(data.fontFormat)
    }
    if (typeof data.formatFlavor === 'string') {
      format.push(data.formatFlavor)
    }
    return format.join(' ')
  }
  const _build = (binaries) => {
    for (const binary of binaries) {
      const mdData = (binary.fontInfo || {})
      binary.styleName = binary.styleName || _getStyleName(mdData)
      binary.familyName = binary.familyName || _getFamilyName(mdData)
      binary.format = binary.format || _getFormat(mdData)
    }
    return binaries
  }
  return {
    buildBinaries: _build
  }
})()

const ErrorToasterBinary = (invalidFilesArray, fileSizeExceedType, invalidExtensionsType, duplicateErrorType) => {
  const fileSizeExceeded = [];
  const invalidFileExtensionFiles = [];
  const duplicatedFiles = [];

  for (const file of invalidFilesArray) {
    if (file.errorName === fileSizeExceedType)
      fileSizeExceeded.push(file.fileName)

    if (file.errorName === invalidExtensionsType)
      invalidFileExtensionFiles.push(file.fileName)

    if (file.errorName === duplicateErrorType)
      duplicatedFiles.push(file.fileName)
  }

  return {
    fileSizeExceeded,
    invalidFileExtensionFiles,
    duplicatedFiles
  }
}

export {
  BinaryHelper,
  ErrorToasterBinary,
  getUploadContentType
}
